import { Injectable } from '@angular/core';

interface ErrorToastBlacklistItem {
    url: string;
    errorCodes: number[];
}

/**
 * Service for showing toast messages.
 */
@Injectable({ providedIn: 'root' })
export class ErrorToastBlacklistService {
    public blacklist: ErrorToastBlacklistItem[] = [];

    public registerToastBlacklistedErrorCode(url: string, code: number): void {
        const blacklistItem = this.blacklist.find((item) => item.url === url.toLowerCase());
        if (blacklistItem) {
            if (!blacklistItem.errorCodes.includes(code)) {
                blacklistItem.errorCodes.push(code);
            }
        } else {
            this.blacklist.push({
                url: url.toLowerCase(),
                errorCodes: [code]
            });
        }
    }

    public unregisterToastBlacklistedErrorCode(url: string, code: number): void {
        const blacklistItemIndex = this.blacklist.findIndex(
            (item) => item.url === url.toLowerCase()
        );
        const blacklistItem = this.blacklist[blacklistItemIndex];
        if (blacklistItem) {
            const codeIndex = blacklistItem.errorCodes.indexOf(code);
            if (codeIndex > -1) {
                blacklistItem.errorCodes.splice(codeIndex, 1);
            }
            // If errorCodes array is empty, remove the whole object.
            if (!blacklistItem.errorCodes.length) {
                this.blacklist.splice(blacklistItemIndex, 1);
            }
        }
    }
}
